import { useCallback } from 'react';

import { MtfElementInput } from '@/types/schema';

import { MtfComponentActionEnum, onMtfComponentAction } from '../useMtfComponentActions/actions';

type Params = {
  index: number;
  onAction: onMtfComponentAction;
  leftElement: MtfElementInput;
  rightElement: MtfElementInput;
};

const useMtfEditorOptionsListItem = ({ onAction, index, leftElement, rightElement }: Params) => {
  const onChangeLeftElementText = (text: string) => {
    onAction({
      type: MtfComponentActionEnum.UpdateOption,
      payload: { index, leftElement: { ...leftElement, text } },
    });
  };

  const onChangeRightElementText = (text: string) => {
    onAction({
      type: MtfComponentActionEnum.UpdateOption,
      payload: { index, rightElement: { ...rightElement, text } },
    });
  };

  const onRemove = useCallback(() => {
    onAction({ type: MtfComponentActionEnum.RemoveOption, payload: { index } });
  }, [index, onAction]);

  return { onChangeLeftElementText, onRemove, onChangeRightElementText };
};

export default useMtfEditorOptionsListItem;
